import { GoogleAdUnit } from '@/components/@google/GoogleAdUnit';
import { project } from '@/lib/project';
import clsx from 'clsx';
import { random } from 'lodash-es';
import dynamic from 'next/dynamic';
import { useRef, useState } from 'react';
import { useHover, useMediaQuery } from 'usehooks-ts';

const BottomDialog = dynamic(() =>
	import('@/components/ui/BottomDialog', { ssr: false })
);

export default function VideoReview({ video }) {
	const randomRotation = random(-3, 3, true).toPrecision(6);
	const hoverRef = useRef(null);
	const isHover = useHover(hoverRef);
	const [isPlaying, setIsPlaying] = useState(false);
	const matches = useMediaQuery('(min-width: 1024px)');

	const handleVideoClick = () => {
		setIsPlaying(true);
	};

	return (
		<>
			<div
				ref={hoverRef}
				onClick={handleVideoClick}
				className={clsx(
					'group relative block aspect-[3/4] h-[248px] w-[140px] flex-shrink-0 rounded-lg  shadow-md transition-transform duration-100 hover:z-20 hover:scale-110 hover:shadow-2xl lg:-mx-2 xl:h-[300px] xl:w-[169px]'
				)}
				style={
					matches
						? {
								transform: isHover
									? 'rotate(0deg)'
									: `rotate(${randomRotation}deg)`,
						  }
						: {}
				}
			>
				<div className="relative h-full w-full cursor-pointer rounded-lg px-px">
					<img
						src={`https://i.ytimg.com/vi/${video.id}/maxresdefault.jpg`}
						loading="lazy"
						draggable="false"
						alt={video.title || video.id}
						sizes="100vw"
						className="size-full relative z-10 max-w-none rounded-lg object-cover group-hover:opacity-0"
					/>
					<div className="absolute inset-0 h-full w-full overflow-hidden rounded-lg object-cover opacity-0 group-hover:opacity-100">
						<div
							onClick={handleVideoClick}
							className="absolute inset-0 z-10 rounded-lg bg-transparent"
						/>
						<iframe
							src={`https://www.youtube.com/embed/${video.id}?autoplay=${
								isHover ? 1 : 0
							}&mute=1&controls=0&playsinline=1&fs=0&disablekb=1`}
							title={'Video Player'}
							className="-z-10 h-full w-full"
							allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen"
							referrerPolicy="strict-origin-when-cross-origin"
						></iframe>
					</div>
				</div>
			</div>
			<BottomDialog
				title={video.title}
				onClose={() => setIsPlaying(false)}
				isOpen={isPlaying}
			>
				<iframe
					src={`https://www.youtube.com/embed/${video.id}?autoplay=1&mute=1`}
					title={'Video Player'}
					className="aspect-video w-full"
					allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen"
					referrerPolicy="strict-origin-when-cross-origin"
				></iframe>

				<GoogleAdUnit
					containerClassName={'max-h-[90px] w-full mt-2'}
					slotId={project.adSense.video}
					adFormat={'horizontal'}
				/>
			</BottomDialog>
		</>
	);
}
